/**
 * Generated API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const IntakeStatus = {
    Incomplete: 'INCOMPLETE',
    NotApplicable: 'NOT_APPLICABLE',
    PendingAnalysis: 'PENDING_ANALYSIS',
    ReviewFindings: 'REVIEW_FINDINGS',
    ConfirmReuse: 'CONFIRM_REUSE',
    Decided: 'DECIDED'
} as const;
export type IntakeStatus = typeof IntakeStatus[keyof typeof IntakeStatus];

